<script lang="ts">
  import i18n from '../../../../../i18n'
  import Button from '../../../../../components/button/Button.svelte'
  import { useProjectQueries } from '../../../../../hooks/project'
  import useObjectsQueries from '../../../hooks/useObjectsQueries'
  import { ThreeItemKeys, ThreeItemTypes } from '../../../../../constants/three'
  import { getContext } from 'svelte'
  import type { Writable } from 'svelte/store'
  import { LoaderCircle, Play } from '@lucide/svelte'
  import { goto } from '@mateothegreat/svelte5-router'

  const { printerId }: { printerId: string } = $props()

  const projectId = getContext<Writable<Project['id']>>('projectId')
  const { saveProjectMutation } = useProjectQueries()

  const { useObjects } = useObjectsQueries()
  const allObjects = $derived(useObjects())
  const isExportable = $derived(
    (allObjects.data ?? []).filter(
      item =>
        item.userData[ThreeItemKeys.ITEM_TYPE] === ThreeItemTypes.FILE
          && item.userData[ThreeItemKeys.ASSIGNED_PRINTER_ID] === printerId,
    ).length > 0,
  )

  const previewPrinter = async () => {
    // saveMutation removes canvasSelection so the selected printer id becomes undefined after the mutateAsync
    const cachedPrinterId = printerId
    await saveProjectMutation.mutateAsync()
    goto(`/projects/${$projectId}/preview?printer_id=${cachedPrinterId}`)
  }
</script>

<div class="buttons-container">
  <Button
    disabled={!isExportable || saveProjectMutation.isPending}
    onclick={previewPrinter}
  >
    {#if saveProjectMutation.isPending}
      {$i18n.t('project.rightBar.preview.pending')}
      <LoaderCircle class="spin" />
    {:else}
      {$i18n.t('project.rightBar.preview.action')}
      <Play fill="currentColor" />
    {/if}
  </Button>
</div>

<style lang="scss">
  .buttons-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
    border-top: 1px solid var(--grid-stroke);
    gap: 0.5rem;

    // :global(.button) {
    //   width: 100%;
    // }
  }

  :global(.spin) {
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
